module.exports = __webpack_public_path__ + "static/media/SBIN.260f716b.txt";